"use strict";

exports.__esModule = true;
exports.float = void 0;
var _domain = require("../domain");
const float = {
  types: ['FLOAT', 'DOUBLE', 'google.protobuf.FloatValue', 'google.protobuf.DoubleValue'],
  [_domain.ConverterType.TO_JSON]: {
    transform: val => {
      return isFinite(val) ? val : val.toString();
    }
  },
  [_domain.ConverterType.FROM_JSON]: {
    transform: val => {
      if (val === 'NaN') {
        return NaN;
      }
      if (val === 'Infinity') {
        return Infinity;
      }
      if (val === '-Infinity') {
        return -Infinity;
      }
      return val;
    }
  }
};
exports.float = float;
//# sourceMappingURL=float.js.map